import { doGraphqlRequest } from 'ducks/requests/operations'
import { UPDATE_COMPANY_PROFILE } from './types'

const mutation = `
  mutation updateCompanyProfile(
    $input: CompanyProfileInput!
  ){
    updateCompanyProfile(
      input: $input
    ) {
      numberOfEmployees
      currentSupportSolution
      industry
      name
      websiteUrl
      phone
    }
  }
`

export function doUpdateCompanyProfile(params) {
  return dispatch => {
    return dispatch(
      doGraphqlRequest(
        UPDATE_COMPANY_PROFILE,
        mutation,
        {
          input: params,
        },
        { throwOnError: true }
      )
    )
  }
}
